import { createApiInstance } from '@/infrastructure/apis/apiInstance'

export async function getUserFrontendActionForNotification({ notificationId }) {
  const response = await createApiInstance().get(`/Notifications/user-frontend-action/${notificationId}`)
  //return response.data as ???
  return response.data
}
